import { format } from "date-fns";
import { logService } from "./logService";

export class DateService {
  isValidDate(value: string): boolean {
    if (!value.includes("T")) return false;

    let formatOk = /\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}/.test(value);
    if (!formatOk) return false;

    formatOk = /\d{4}-\d{2}-\d{2}/.test(value);
    if (!formatOk) return false;

    // dateString: '2000-01-01T00:00:00+01:00'
    // date: Sat Jan 01 2000 00:00:00 GMT+0100 (közép-európai téli idő)
    // toDateString: Sat Jan 01 2000
    // toLocaleString: 2000. 01. 01. 0:00:00
    // toISOString: 1999-12-31T23:00:00.000Z
    // toUTCString: Fri, 31 Dec 1999 23:00:00 GMT
    // toString: Sat Jan 01 2000 00:00:00 GMT+0100 (közép-európai téli idő)
    // datePipe.transform: 2000-01-01T00:00:00

    const date = new Date(value);
    const formattedDate = format(date, "yyyy-MM-dd'T'HH:mm:ss");
    const valid =
      date instanceof Date &&
      !isNaN(date.getTime()) &&
      value.startsWith(formattedDate);

    if (!valid) logService.error("DateService !isValidDate", value, date);

    return valid;
  }

  datesFromUTCString(dataModel: any, conversion?: (date: Date) => Date) {
    const entries = Object.entries(dataModel);
    for (const [key, value] of entries) {
      if (typeof value === "string") {
        const valid = this.isValidDate(value);
        if (valid) {
          const date = new Date(value);
          dataModel[key] = conversion ? conversion(date) : date;
        }
      }
    }
    return dataModel;
  }

  datesToUTC(dataModel: any) {
    if (!dataModel) return dataModel;
    if (
      typeof dataModel === "object" &&
      !Array.isArray(dataModel) &&
      !(dataModel instanceof Date)
    ) {
      const entries = Object.entries<any>(dataModel);
      for (const [key, value] of entries) {
        if (value && value.getMonth) {
          dataModel[key] = this.localToUTC(value as Date);
        }
      }
    }
    return dataModel;
  }

  localToUTC(date: Date): Date {
    return new Date(
      Date.UTC(
        date.getFullYear(),
        date.getMonth(),
        date.getDate(),
        date.getHours(),
        date.getMinutes(),
        date.getSeconds()
      )
    );
  }

  utcToLocal(date: Date): Date {
    return new Date(
      date.getUTCFullYear(),
      date.getUTCMonth(),
      date.getUTCDate(),
      date.getUTCHours(),
      date.getUTCMinutes(),
      date.getUTCSeconds()
    );
  }
}

export const dateService = new DateService();
